// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1Lbsp","unreadBadge":"styles_unreadBadge__2t97u","modalContent":"styles_modalContent__1BoCJ","modal":"styles_modal__30ziC"};